import React, { useEffect, useMemo, useState } from 'react';
import useOrders from '../../hooks/react-query/useOrder';
import OrderedCardOverView from './orderedCardOverView';
import { CardListSkeletion } from '../elements/skeletions';
import { manageOrderedCarList, mapStepToText } from '../../utils/helper';
import OrderCarCard from './orderCarCard';
import OrderTrackingCorporateView from './orderTrackingCorporateView';

export const CarOrderedList = ({ searchTerm, handleCarSelection, carList}) => {
  const { data: orderedCars, isLoading } = useOrders();
  const [selectedCar, setSelectedCar] = useState(null);

  const [orderCarList, setOrderedCarList] = useState([]);
  const [inprogressCarList, setInProgressCarList] = useState([]);

  useEffect(() => {
    if (searchTerm && selectedCar) {
      setSelectedCar(null);
    }
  }, [searchTerm]);

  const updatedCarList = useMemo(() => {
    return orderedCars?.data ? manageOrderedCarList(orderedCars?.data) : [];
  }, [orderedCars?.data]);

  useEffect(() => {
    const { orderedCarsList, carInprogressList } = updatedCarList;
    if (orderedCarsList) {
      if (searchTerm) {
        const searchList = orderedCarsList.filter((item) => {
          const testString = `${item.cncode}`.toLowerCase();

          return testString.includes(searchTerm.toLowerCase());
        });
        setOrderedCarList(searchList);
      } else {
        setOrderedCarList(orderedCarsList);
      }
    }

    if (carInprogressList) {
      if (searchTerm) {
        const searchList = carInprogressList.filter((item) => {
          const testString = `${item.cncode}`.toLowerCase();

          return testString.includes(searchTerm.toLowerCase());
        });
        setInProgressCarList(searchList);
      } else {
        setInProgressCarList(carInprogressList);
      }
    }
  }, [searchTerm, updatedCarList, orderedCars]);

  if (isLoading) {
    return <CardListSkeletion />;
  }

  return (
    <>
      <ul
        className={`${
          selectedCar ? 'col-span-3 lg:grid-cols-2' : 'col-span-4 lg:grid-cols-3'
        } grid  gap-3  overflow-y-auto pe-3 max-h-[70vh] h-fit scrollbar`}
      >
        {orderCarList.length > 0 ? (
          orderCarList.map((car) => {
            const carData = {
              ...car,
              title: car.carTitle,
              subTitle: car?.carSubTitle,
              info: mapStepToText(car.state?.step),
              plateno: car.cncode,
              step: car.state?.step,
            };
            return (
              <OrderCarCard
                isOrderdCar={true}
                carData={carData}
                selectedCar={selectedCar}
                handleCardClick={() => {
                  setSelectedCar(carData);
                  handleCarSelection(carData);
                }}
                key={car.cncode}
                className="h-fit"
              />
            );
          })
        ) : (
          <></>
        )}

        {inprogressCarList.length > 0 ? (
          inprogressCarList.map((car) => {
            const carData = {
              ...car,
              title: car.carTitle,
              subTitle: car?.carSubTitle,
              info: mapStepToText(car.state?.step),
              plateno: car.cncode,
              step: car.state?.step,
            };
            return (
              <OrderCarCard
                isOrderdCar={true}
                carData={carData}
                selectedCar={selectedCar}
                handleCardClick={() => {
                  setSelectedCar(carData);
                  handleCarSelection(carData);
                }}
                key={car.cncode}
                className="h-fit"
              />
            );
          })
        ) : orderedCars?.data?.length ? (
          <></>
        ) : (
          <p className="text-body text-center">
            Κανένα αποτέλεσμα
          </p>
        )}
      </ul>
      {/* {selectedCar && <OrderedCardOverView carData={selectedCar} />} */}
      {selectedCar && <OrderTrackingCorporateView orderData={selectedCar} carList={carList}/>}
    </>
  );
};

export default CarOrderedList;
